<header class="header-page row">
  <h1 class="col-sm-12 col-md-7 col-xl-7 px-0 header__page__content__title">
    Adesão dos Beneficiários
  </h1>
  <div class="col-sm-12 col-md-5 col-xl-5 px-1">
    <a type="button" [routerLink]="['/historico-adesao']"
      class="btn btn-outline-primary btn-outline-primary-historico float-right">
      <span>Minhas Solicitações</span>
    </a>
  </div>
</header>
<main class="col-xl-12 px-2 main__content">
  <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formData"
    (ngSubmit)="sendTo()">
    <section class="content-form">
      <div class="col-xl-4 mb-2 px-1">
        <label class="content__form__title__label">Tipo de Adesão <span class="label__form__required"> *</span> </label>
        <ng-select [clearable]="false" [items]="listaTipoAdesao" [searchable]="false"
          (change)="accessionTypeChanged($event)" (close)="accessionSelected($event)" bindLabel="nome" bindValue="id"
          placeholder="Selecione" formControlName="adesaoId">
        </ng-select>
        <small class="form-text text-muted danger "
          *ngIf="formData.get('adesaoId')?.touched && formData.get('adesaoId')?.invalid" [@fadeIn]>
          Por favor, selecione um Tipo de Adesão!
        </small>
      </div>
    </section>
    <br>
    <section [@fadeIn] *ngIf="showForm && formData.value.adesaoId">
      <!-- <section class="form-body row">
                <div class="col-12 pt-2 px-1 mb-2">
                    <h3>
                      Dados do Dependente
                    </h3>
                  </div>
            </section> -->
      <section class="content-form">
        <h4>
          Dados do Dependente
        </h4>
        <section class="row" formGroupName="dadosDependente">
          <div class="col-lg-4 col-md-6 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Nome (completo e sem abreviações) <span
                class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="Nome completo"
              formControlName="nome">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.nome')?.touched && formData.get('dadosDependente.nome')?.invalid"
              [@fadeIn]>
              Por favor, informe o Nome Completo!
            </small>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Vínculo de dependência <span class="label__form__required">*</span></label>
            <ng-select [appendTo]="'body'" [clearable]="false" [items]="listaVinculoDependencia" [searchable]="false"
              class="ng-pristine" bindLabel="nome" bindValue="id" placeholder="Selecione" formControlName="vinculo">
            </ng-select>
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.vinculo')?.touched && formData.get('dadosDependente.vinculo')?.invalid"
              [@fadeIn]>
              Por favor, selecione o vinculo!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Data de nascimento <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" type="date" placeholder="Nome completo"
              max="{{today | date:'yyyy-MM-dd'}}" formControlName="dataNascimento">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.dataNascimento')?.touched && formData.get('dadosDependente.dataNascimento')?.invalid && !formData.get('dadosDependente.dataNascimento')?.hasError('invalidIdade')"
              [@fadeIn]>
              Por favor, informe sua data de nascimento!
            </small>
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.dataNascimento')?.touched && formData.get('dadosDependente.dataNascimento')?.hasError('invalidIdade')"
              [@fadeInOut]>
              {{mensagemData}}
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">CPF <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" maxlength="14" placeholder="___.___.___-__"
              mask="000.000.000-00" formControlName="cpf">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.cpf')?.touched && formData.get('dadosDependente.cpf')?.invalid"
              [@fadeIn]>
              Por favor, informe o CPF!
            </small>
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.cpf')?.touched && formData.get('dadosDependente.cpf')?.invalid"
              [@fadeIn]>
              Por favor, informe um CPF válido!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">RG</label>
            <input class="form-control input-form input-form-details" placeholder="" formControlName="rg">
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Nacionalidade <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="" formControlName="nacionalidade">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.nacionalidade')?.touched && formData.get('dadosDependente.nacionalidade')?.invalid"
              [@fadeIn]>
              Por favor, informe a nacionalidade!
            </small>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Nome da mãe (completo e sem abreviações) <span
                class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="Nome completo da mãe"
              formControlName="nomeMae">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.nomeMae')?.touched && formData.get('dadosDependente.nomeMae')?.invalid"
              [@fadeIn]>
              Por favor, informe o nome da mãe!
            </small>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Nome do pai (completo e sem abreviações)</label>
            <input class="form-control input-form input-form-details" placeholder="Nome completo da pai"
              formControlName="nomePai">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.nomePai')?.touched && formData.get('dadosDependente.nomePai')?.invalid"
              [@fadeIn]>
              Por favor, informe o nome do pai!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Sexo <span class="label__form__required">*</span></label>
            <ng-select [clearable]="false" [items]="listaSexo" bindLabel="nome" bindValue="nome" placeholder="Selecione"
              formControlName="sexo">
            </ng-select>
            <small class="form-text text-muted danger "
              *ngIf="formData.get('sexo')?.touched && formData.get('sexo')?.invalid" [@fadeIn]>
              Por favor, informe o sexo que consta na sua carteira de identidade!
            </small>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">CNS (Carteira Nacional de Saúde - SUS)</label>
            <input class="form-control input-form input-form-details" placeholder="Informe a sua CNS"
              formControlName="cns">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.cns')?.touched && formData.get('dadosDependente.cns')?.invalid"
              [@fadeIn]>
              Por favor, informe o CNS!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Telefone Celular <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="(XX) XXXXX-XXXX"
              mask="(XX) XXXXX-XXXX" formControlName="telefoneCelular">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.telefoneCelular')?.touched && formData.get('dadosDependente.telefoneCelular')?.invalid"
              [@fadeIn]>
              Por favor, informe o Celular!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">Telefone residencial </label>
            <input class="form-control input-form input-form-details" placeholder="(XX) XXXX-XXXX" mask="(XX) XXXX-XXXX"
              formControlName="telefoneResidencial">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.telefoneResidencial')?.touched && formData.get('dadosDependente.telefoneResidencial')?.invalid"
              [@fadeIn]>
              Por favor, informe o Telefone!
            </small>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 pt-2 px-1" [@fadeIn]>
            <label class="label-form">E-mail <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="" formControlName="email">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('dadosDependente.email')?.touched && formData.get('dadosDependente.email')?.invalid"
              [@fadeIn]>
              Por favor, informe o e-mail!
            </small>
          </div>
        </section>
        <section class="row" formGroupName="endereco" [@fadeIn] *ngIf="!this.formData.value.enderecoTitular">
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1">
            <label class="label-form">CEP <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="XXXXX-XXX" mask="XXXXX-XXX"
              formControlName="cep" (change)="cepChanged($event)">
            <a class="link-cep" href="https://www2.correios.com.br/sistemas/buscacep/buscacep.cfm" target="_blank">Não
              sei o meu cep</a>
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('endereco.cep')?.touched && formData.get('endereco.cep')?.invalid" [@fadeIn]>
              Por favor, informe o CEP!
            </small>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1">
            <label class="label-form">Endereço <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="Informe o seu endereço"
              formControlName="rua">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('endereco.rua')?.touched && formData.get('endereco.rua')?.invalid" [@fadeIn]>
              Por favor, informe o Endereço!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1">
            <label class="label-form">Bairro <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="Informe o seu bairro"
              formControlName="bairro">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('endereco.bairro')?.touched && formData.get('endereco.bairro')?.invalid" [@fadeIn]>
              Por favor, informe o Bairro!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1">
            <label class="label-form">Número <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="" formControlName="numero">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('endereco.numero')?.touched && formData.get('endereco.numero')?.invalid" [@fadeIn]>
              Por favor, informe o Número!
            </small>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-12 pt-2 px-1">
            <label class="label-form">Complemento</label>
            <input class="form-control input-form input-form-details" placeholder="Informe o seu complemento"
              formControlName="complemento">
          </div>
          <div class="col-lg-1 col-md-4 col-sm-12 pt-2 px-1">
            <label class="label-form">UF <span class="label__form__required">*</span></label>
            <ng-select (close)="pesquisarUf()" [clearable]="false" [items]="ufOptions" bindLabel="value"
              bindValue="value" placeholder="Selecione" formControlName="uf">
            </ng-select>
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('endereco.uf')?.touched && formData.get('endereco.uf')?.invalid" [@fadeIn]>
              Por favor, informe o UF!
            </small>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-12 pt-2 px-1">
            <label class="label-form">Cidade <span class="label__form__required">*</span></label>
            <input class="form-control input-form input-form-details" placeholder="Informe o seu cidade"
              formControlName="cidade">
            <small class="form-text text-muted danger ng-pristine"
              *ngIf="formData.get('endereco.cidade')?.touched && formData.get('endereco.cidade')?.invalid" [@fadeIn]>
              Por favor, informe a Cidade!
            </small>
          </div>
        </section>
        <div class="form-check form-check-endereco d-flex" [@fadeIn]>
          <input type="checkbox" class="form-check-input" id="enderecoTitular" formControlName="enderecoTitular"
            name="enderecoTitular" (click)="enderecoTitular()">
          <label class="form-check-label check-label" for="enderecoTitular">
            Utilizar o meu endereço cadastrado
          </label>
        </div>
      </section>
    </section>
    <section class="form-body row" *ngIf="showForm && formData.value.adesaoId" [@fadeIn]>
      <!-- <div class="col-12 pt-2 px-1 mb-2">
              <h4>
                Upload de arquivos
              </h4>
            </div> -->
      <!-- UPLOAD DE ARQUIVOS BEGIN -->
      <section class="content-form col-12 px-0 mt-2">
        <h4>
          Upload de arquivos
        </h4>
        <section class="row">
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.termoGuardaTutela.disabled">
            <form-input
              [errorRequired]="(formData.get('termoGuardaTutela.file')?.touched && formData.get('termoGuardaTutela.file')?.value == null)"
              [labelInput]="'Termo de guarda '" [isMultiple]="true" [isRequired]="true"
              [tipoDocumento]="'termoGuardaTutela'" (adicionar)="adicionarArquivos('termoGuardaTutela',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row"
                *ngFor="let itemFile of formData.get('termoGuardaTutela.file')?.value; let i = index" [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x"
                    (click)="removeFile('termoGuardaTutela',i)" [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.termoConsentimento.disabled">
            <form-input
              [errorRequired]="(formData.get('termoConsentimento.file')?.touched && formData.get('termoConsentimento.file')?.value == null)"
              [labelInput]="'Termo de consentimento assinado pelo responsável '" [isMultiple]="true" [isRequired]="true"
              [tipoDocumento]="'termoConsentimento'" (adicionar)="adicionarArquivos('termoConsentimento',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row"
                *ngFor="let itemFile of formData.get('termoConsentimento.file')?.value; let i = index" [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x"
                    (click)="removeFile('termoConsentimento',i)" [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.documentoResponsavelLegal.disabled">
            <form-input
              [errorRequired]="(formData.get('documentoResponsavelLegal.file')?.touched && formData.get('documentoResponsavelLegal.file')?.value == null)"
              [labelInput]="'CPF do Responsável Legal (Frente e Verso)'" [isMultiple]="true" [isRequired]="true"
              [tipoDocumento]="'documentoResponsavelLegal'"
              (adicionar)="adicionarArquivos('documentoResponsavelLegal',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row"
                *ngFor="let itemFile of formData.get('documentoResponsavelLegal.file')?.value; let i = index" [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x"
                    (click)="removeFile('documentoResponsavelLegal',i)" [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.certidaoCasamento.disabled">
            <form-input
              [errorRequired]="(formData.get('certidaoCasamento.file')?.touched && formData.get('certidaoCasamento.file')?.value == null)"
              [labelInput]="'Certidão de Casamento '" [isMultiple]="true" [isRequired]="true"
              [tipoDocumento]="'certidaoCasamento'" (adicionar)="adicionarArquivos('certidaoCasamento',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row"
                *ngFor="let itemFile of formData.get('certidaoCasamento.file')?.value; let i = index" [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x"
                    (click)="removeFile('certidaoCasamento',i)" [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.certidaoNascimento.disabled">
            <form-input
              [errorRequired]="(formData.get('certidaoNascimento.file')?.touched && formData.get('certidaoNascimento.file')?.value == null)"
              [labelInput]="'Certidão de Nascimento do dependente '" [isMultiple]="true" [isRequired]="true"
              [tipoDocumento]="'certidaoNascimento'" (adicionar)="adicionarArquivos('certidaoNascimento',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row"
                *ngFor="let itemFile of formData.get('certidaoNascimento.file')?.value; let i = index" [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x"
                    (click)="removeFile('certidaoNascimento',i)" [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.declaracaoVidaConjunta.disabled">
            <form-input
              [errorRequired]="(formData.get('declaracaoVidaConjunta.file')?.touched && formData.get('declaracaoVidaConjunta.file')?.value == null)"
              [labelInput]="'Declaração Particular Conjunta de vida '" [isMultiple]="true" [isRequired]="true"
              [tipoDocumento]="'declaracaoVidaConjunta'"
              (adicionar)="adicionarArquivos('declaracaoVidaConjunta',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row"
                *ngFor="let itemFile of formData.get('declaracaoVidaConjunta.file')?.value; let i = index" [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x"
                    (click)="removeFile('declaracaoVidaConjunta',i)" [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0" *ngIf="!formData.controls.rg.disabled">
            <form-input [errorRequired]="(formData.get('rg.file')?.touched && formData.get('rg.file')?.value == null)"
              [labelInput]="'RG do Dependente (Frente e Verso) '" [isMultiple]="true" [isRequired]="false"
              [tipoDocumento]="'rg'" (adicionar)="adicionarArquivos('rg',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row" *ngFor="let itemFile of formData.get('rg.file')?.value; let i = index" [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile('rg',i)"
                    [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0" *ngIf="!formData.controls.cpfOuCnh.disabled">
            <form-input
              [errorRequired]="(formData.get('cpfOuCnh.file')?.touched && formData.get('cpfOuCnh.file')?.value == null)"
              [labelInput]="'CPF do Dependente (Frente e Verso) '" [isMultiple]="true" [isRequired]="true"
              [tipoDocumento]="'cpfOuCnh'" (adicionar)="adicionarArquivos('cpfOuCnh',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row" *ngFor="let itemFile of formData.get('cpfOuCnh.file')?.value; let i = index"
                [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile('cpfOuCnh',i)"
                    [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.dadosBancarios.disabled">
            <form-input
              [errorRequired]="(formData.get('dadosBancarios.file')?.touched && formData.get('dadosBancarios.file')?.value == null)"
              [labelInput]="'Cópia do Cartão e/ou print do cabeçalho do extrato bancário (vedar o código de segurança) '"
              [isMultiple]="true" [isRequired]="true" [tipoDocumento]="'dadosBancarios'"
              (adicionar)="adicionarArquivos('dadosBancarios',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row" *ngFor="let itemFile of formData.get('dadosBancarios.file')?.value; let i = index"
                [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile('dadosBancarios',i)"
                    [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="col-lg-4 col-md-4 col-sm-12 pt-2 px-1 pt-md-0"
            *ngIf="!formData.controls.dadosBancarios.disabled">
            <form-input
              [errorRequired]="(formData.get('dadosBancarios.file')?.touched && formData.get('dadosBancarios.file')?.value == null)"
              [labelInput]="'Declaração particular conjunta de vida em comum registrada em cartório ou declaração conjunta/escritura pública de convivência '"
              [isMultiple]="true" [isRequired]="true" [tipoDocumento]="'dadosBancarios'"
              (adicionar)="adicionarArquivos('dadosBancarios',$event)">
            </form-input>
            <section class="col-xl-12 p-0 content-form-lista">
              <div class="lista-row" *ngFor="let itemFile of formData.get('dadosBancarios.file')?.value; let i = index"
                [@fadeIn]>
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile('dadosBancarios',i)"
                    [icon]="faSquareXmark">
                  </fa-icon>
                </div>
              </div>
            </section>
          </section>
          <section class="content-checkbox" *ngIf="!formData.controls.aceites.disabled" [@fadeIn]>
            <h5 class="mb-1">
              Leia com atenção
            </h5>
            <section formGroupName="aceites">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="aceiteConfirmaCredenciamento"
                  formControlName="aceiteConfirmaCredenciamento" name="aceiteConfirmaCredenciamento">
                <label class="form-check-label check-label" for="aceiteConfirmaCredenciamento">
                  Com o teor do Estatuto da Fundação Copel e do Regulamento do {{ formData.get('tipoPlano')?.value|
                  uppercase }} registrado na ANS sob o nº {{actualUser?.healthProfile?.description != 'ProSaúde II' ?
                  '475.211-15/2' : '468.270-12/0'}}, bem como todos os documentos que neste ato estou recebendo a
                  (relação da rede credenciada e percentual de participação na mensalidade)
                </label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="aceiteInclusaoCompanheiro"
                  formControlName="aceiteInclusaoCompanheiro" name="aceiteInclusaoCompanheiro">
                <label class="form-check-label check-label" for="aceiteInclusaoCompanheiro">
                  Que a inclusão do (a) meu / minha companheiro (a) não dá direito a usufruir os benefícios ofertados
                  nos demais planos administrados pela Fundação Copel;
                </label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="aceiteDespesasCoparticipacao"
                  formControlName="aceiteDespesasCoparticipacao" name="aceiteDespesasCoparticipacao">
                <label class="form-check-label check-label" for="aceiteDespesasCoparticipacao">
                  É de minha total e irrestrita responsabilidade arcar com todas as despesas referentes à mensalidade e
                  coparticipação do (a) meu / minha companheiro (a) no {{ actualUser.healthProfile?.description |
                  uppercase }}.
                </label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="aceiteOmissaoPedido"
                  formControlName="aceiteOmissaoPedido" name="aceiteOmissaoPedido">
                <label class="form-check-label check-label" for="aceiteOmissaoPedido">
                  Que não cabe posterior alegação de omissão no Pedido de Inscrição por parte da Fundação Copel para os
                  benefícios a que tenho direito;
                </label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="aceiteDependenciaEconomica"
                  formControlName="aceiteDependenciaEconomica" name="aceiteDependenciaEconomica">
                <label class="form-check-label check-label" for="aceiteDependenciaEconomica">
                  Declaro, ainda, que o(a) dependente acima estão sob a minha dependência econômica, assumindo o
                  compromisso de comunicar de imediato à Fundação Copel qualquer alteração destas condições;
                </label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="aceiteResponsabilidadeDeclaracoes"
                  formControlName="aceiteResponsabilidadeDeclaracoes" name="aceiteResponsabilidadeDeclaracoes">
                <label class="form-check-label check-label" for="aceiteResponsabilidadeDeclaracoes">
                  Assumo a responsabilidade de todas as declarações feitas por mim e pela veracidade destas, estando
                  ciente das sansões disciplinares previstas no regulamento e de todas as informações sobre o {{
                  actualUser.healthProfile?.description | uppercase }} como carências, coberturas, mecanismos de
                  regulação, reajustes, vigências e regras de rescisão e/ou suspensão.
                </label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="aceiteDescontoFolhaPagamento"
                  formControlName="aceiteDescontoFolhaPagamento" name="aceiteDescontoFolhaPagamento">
                <label class="form-check-label check-label" for="aceiteDescontoFolhaPagamento">
                  Autorizo a Fundação Copel a descontar, mensalmente na folha de pagamento, os valores relativos às
                  mensalidades e coparticipações, na forma prevista no Regulamento do {{
                  actualUser.healthProfile?.description | uppercase }}, em favor da Fundação Copel de Previdência e
                  Assistência Social;
                </label>
              </div>
              <div class="mt-1 form-details">
                <span>
                  Em caso de dúvida entrar em contato com a Fundação Copel por meio de canais de atendimento;
                </span>
              </div>
            </section>
          </section>
        </section>
      </section>
      <!-- UPLOAD DE ARQUIVOS END -->
      <section class="content-buttons">
        <div class="form-actions my-4 ">
          <div class="div-button float-right">
            <button type="submit" class="btn btn-primary px-4" (click)="sendTo()">
              <span class="btn-span">Continuar</span>
            </button>
          </div>
        </div>
        <div class="form-actions my-4 ">
          <div class="div-button float-right">
            <button type="submit" class="btn btn-outline-primary px-4 mr-xl-1 mr-lg-1 mr-md-1 mr-sm-0"
              (click)="resetForm()">
              <span class="btn-span">Cancelar</span>
            </button>
          </div>
        </div>
      </section>
    </section>
  </form>
</main>